module.exports = __webpack_public_path__ + "static/media/HostGuidelines.0064dcee.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/HostGuidelines.pdf
// module id = 188
// module chunks = 0